<template>
  <div class="help-content">
    <h2>Help Center</h2>
    <b>Here is the contact information for SWD Group</b>
    <br />
    <p><b>General Contact Information</b></p>
    <div>Phone: <b>877-934-7687</b> Email: <b>info@swdgroup.com</b></div>
    <p><b>Office Locations</b></p>
    <span v-for="(officeLocation, index) in office" :key="index" class="faq-item">
      <div class="faq-question" @click="toggleAnswer(index)">
        <span class="toggle-symbol">
          {{ officeLocation.showAnswer ? '-' : '+' }}
        </span>
        <span class="question-text">{{ officeLocation.question }}</span>
      </div>
      <div v-if="officeLocation.showAnswer" class="faq-answer">
        <p>{{ officeLocation.address }}</p>
        <p>{{ officeLocation.phone }}</p>
      </div>
    </span>
    <div>
      This information provides a comprehensive overview of how to reach SWD Group and their various office locations
      across the United States.
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      office: [
        {
          question: 'Atlanta, GA',
          address: 'Address: 1100 Abernathy Road N.E., Suite L-20, Atlanta, GA 30328.',
          phone: 'Phone: 678-638-6363',
          showAnswer: false,
        },
        {
          question: 'Austin, TX',
          address: 'Address: 3711 South Mopac Expressway Bldg. 2, Suite 175, Austin, TX 78746.',
          phone: 'Phone: 737-247-7683',
          showAnswer: false,
        },
        {
          question: 'Charlotte, NC',
          address: 'Address: 13146 Ballantyne Corporate Place, Suite 100, Charlotte, NC 28277.',
          phone: 'Phone: 704-817-4233',
          showAnswer: false,
        },
        {
          question: 'Mason, OH',
          address: 'Address: 5181 Natorp Blvd., Suite 100, Mason, OH 45040.',
          phone: 'Phone: 513-492-2198',
          showAnswer: false,
        },
        {
          question: 'Dallas, TX',
          address: 'Address: 12377 Merit Drive, Suite 120, Dallas, TX 75251.',
          phone: 'Phone: 972-327-6511',
          showAnswer: false,
        },
        {
          question: 'Vienna, VA',
          address: 'Address: 1921 Gallows Road, Suite 110, Vienna, VA 22182.',
          phone: 'Phone: 703-718-6973',
          showAnswer: false,
        },
        {
          question: 'Denver, CO',
          address: 'Address: 4600 S. Syracuse St., Suite 100, Denver, CO 80237.',
          phone: 'Phone: 303-952-4044',
          showAnswer: false,
        },
        {
          question: 'Fort Worth, TX',
          address: 'Address: 101 Summit Ave., Suite 100, Fort Worth, TX 76102.',
          phone: 'Phone: 817-539-8702',
          showAnswer: false,
        },
        {
          question: 'Houston, TX',
          address: 'Address: 2000 W. Sam Houston Pkwy S., Suite 150, Houston, TX 77042.',
          phone: 'Phone: 346-385-0948',
          showAnswer: false,
        },
        {
          question: 'Indianapolis, IN',
          address: 'Address: 9025 River Road, Suite 120, Indianapolis, IN 46240.',
          phone: 'Phone: 317-644-0876',
          showAnswer: false,
        },
        {
          question: 'Louisville, KY',
          address: 'Address: 500 N. Hurstbourne Pkwy., Suite 120, Louisville, KY 40222.',
          phone: 'Phone: 502-412-3354',
          showAnswer: false,
        },
        {
          question: 'Coral Gables, FL',
          address: 'Address: 1 Alhambra Plaza, PH 15, Regus Coral Gables, FL 33134.',
          phone: 'Phone: 623-544-3424',
          showAnswer: false,
        },
        {
          question: 'Peoria, AZ',
          address: 'Address: 9220 W. Union Hills Drive, Suite 101, Peoria, AZ 85382.',
          phone: 'Phone: 737-247-7683',
          showAnswer: false,
        },
        {
          question: 'Raleigh, NC',
          address: 'Address: 8041 Arco Corporate Drive, Suite 130, Raleigh, NC 27617.',
          phone: 'Phone: 919-426-2052',
          showAnswer: false,
        },
        {
          question: 'Bellevue, WA',
          address: 'Address: 3535 Factoria Blvd. SE, Suite 425, Bellevue, WA 98006.',
          phone: 'Phone: 425-658-2197',
          showAnswer: false,
        },
        {
          question: 'Tampa, FL',
          address: 'Address: 3030 N. Rocky Point Drive, Suite 100, Tampa, FL 33607.',
          phone: 'Phone: 813-999-2486',
          showAnswer: false,
        },
        {
          question: 'Westminster, CO',
          address: 'Address: 11030 Circle Point Road, Suite 140 Westminster CO ,80020 .',
          phone: 'Phone: 720-615-1978',
          showAnswer: false,
        },
      ],
    }
  },
  methods: {
    toggleAnswer(index) {
      this.office[index].showAnswer = !this.office[index].showAnswer
    },
  },
}
</script>

<style scoped>
.help-content {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  padding: 5px;
}
.help-content h2 {
  color: #073763;
  font-size: 16px;
  font-weight: bold;
  background-color: #f0eaff;
  padding: 10px;
}

.help-content div {
  font-size: 12px;
}
.faq-item {
  margin-bottom: 10px;
  overflow-y: auto;
}
.faq-question {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  border-radius: 5px;
}
.toggle-symbol {
  margin-right: 10px;
  font-weight: bold;
  color: #073763;
}
.faq-answer {
  padding: 15px;
  background-color: #f0eaff;
}
</style>
